const styles = {
  container: 'py-8 sm:pb-36 w-full',
};

export default styles;
